import { render, staticRenderFns } from "./Tecnica.vue?vue&type=template&id=16937ba8&"
import script from "./Tecnica.vue?vue&type=script&lang=js&"
export * from "./Tecnica.vue?vue&type=script&lang=js&"
import style0 from "./Tecnica.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports